import axios from 'axios';
import { baseUrl } from '@/config';

export default {
  /**
   * [운영설정 > 이벤트설정] managetypeId 별 rsc트리 데이터를 조회한다.
   * @author najongdang
   * @return {[type]}        [description]
   */
  getRscTreeByManagetypeId(params) {
    return axios.post(`${baseUrl}/settings/common/event/get-rsc-tree-by-managetype-id.do`, params);
  },
  /**
   * [운영설정 > 이벤트설정] 선택된 관리자원구분별 이벤트 목록을 가지고 온다
   * @author najongdang
   * @return {[type]}        [description]
   */
  getRscEventList(params) {
    return axios.post(`${baseUrl}/settings/common/event/get-rsc-event-list.do`, params);
  },
  /**
   * [운영설정 > 이벤트설정] 변경된 이벤트 리스트 정보를 수정한다.
   * @author najongdang
   * @return {[type]}        [description]
   */
  updateEventList(params) {
    return axios.post(`${baseUrl}/settings/common/event/update-event-list.do`, params);
  },
  /**
   * [운영설정 > 이벤트설정] 이벤트 리스트를 삭제한다.
   * @author najongdang
   * @return {[type]}        [description]
   */
  deleteEventList(params) {
    return axios.post(`${baseUrl}/settings/common/event/delete-event-list.do`, params);
  },
  /**
   * [운영설정 > 이벤트설정] 이벤트 추가시 event ID validation을 체크한다.
   * @author najongdang
   * @return {[type]}        [description]
   */
  checkEventIdValidation(params) {
    return axios.post(`${baseUrl}/settings/common/event/check-event-id-validation.do`, params);
  },
  /**
   * [운영설정 > 이벤트설정] 이벤트를 추가한다.
   * @author najongdang
   * @return {[type]}        [description]
   */
  insertEvent(params) {
    return axios.post(`${baseUrl}/settings/common/event/insert-event.do`, params);
  },
  /**
   * 이벤트를 수정한다.
   * @author Ju
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   */
  updateEvent(params) {
    return axios.post(`${baseUrl}/settings/common/event/update-event.do`, params);
  },
};



// WEBPACK FOOTER //
// ./src/api/settings/common/event-settings.js